import { render } from "./NewsCard.vue?vue&type=template&id=66c33baa&scoped=true&lang=pug"
import script from "./NewsCard.vue?vue&type=script&lang=ts"
export * from "./NewsCard.vue?vue&type=script&lang=ts"

import "./NewsCard.vue?vue&type=style&index=0&id=66c33baa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-66c33baa"

export default script